export const Types = {
    SAVE_LIST_MEMBER: 'SAVE_LIST_MEMBER',
}
